import { ref, watch, computed } from '@vue/composition-api'
// Notification

import store from '@/store'
import reFetchAPI from '@/utils/refetch-api'
import { errorNotification } from '@/utils/toast-notifications'

export default function useDriversList(props) {
  const refDriverListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'driver' },
    { key: 'externalId' },
    { key: 'phoneNumber' },
    { key: 'nationalId' },
    { key: 'status' },
    { key: 'acceptanceRatio' },
    { key: 'actions' },
  ]
  const perPage = ref(10)
  const totalDrivers = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [2, 10, 25]
  const searchQuery = ref({})
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const loadingDrivers = ref(false)
  const selfRegistered = ref(false)
  const drivers = ref([])
  const quickFilterApplied = ref(false)
  const advancedFilterApplied = ref(false)

  const dataMeta = computed(() => {
    const localItemsCount = refDriverListTable.value ? refDriverListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalDrivers.value,
    }
  })

  const fetchDrivers = async () => {
    if (loadingDrivers.value) return
    if (!Object.keys(searchQuery.value).length && !props.initialFetchList) {
      errorNotification('Apply a filter to search drivers')
      return
    }
    loadingDrivers.value = true
    const requestSearchQuery = { ...searchQuery.value }
    if (quickFilterApplied.value) {
      delete requestSearchQuery.phoneNumber
      delete requestSearchQuery.nationalId
      delete requestSearchQuery.id
    }
    if (advancedFilterApplied.value) {
      delete requestSearchQuery.text
      delete requestSearchQuery.carNumber
    }

    try {
      const response = await store
        .dispatch('drivers/fetchDrivers', {
          ...requestSearchQuery,
          perPage: perPage.value,
          page: currentPage.value,
          sortBy: sortBy.value,
          sortDesc: isSortDirDesc.value,
          activeState: props.isBlockedState ? 'INACTIVE' : undefined,
          selfRegistered: selfRegistered.value || undefined,
        })
      loadingDrivers.value = false
      drivers.value = response.drivers
      totalDrivers.value = response.total
    } catch (error) {
      if (error.message.includes('timeout')) {
        fetchDrivers()
      } else {
        reFetchAPI(fetchDrivers)
        errorNotification('Something went wrong!!, retrying..')
      }
    }
  }
  watch([currentPage, perPage], () => {
    fetchDrivers()
  })

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveDriverActiveStateVariant = status => {
    if (status === 'ACTIVE') return 'success'
    if (status === 'INACTIVE') return 'danger'
    return 'primary'
  }

  return {
    fetchDrivers,
    drivers,
    quickFilterApplied,
    advancedFilterApplied,
    tableColumns,
    perPage,
    currentPage,
    totalDrivers,
    dataMeta,
    selfRegistered,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refDriverListTable,
    loadingDrivers,

    resolveDriverActiveStateVariant,
  }
}
